<div *ngIf="environment.showEnvBanner" class="env-banner">
	<i class="pi pi-info-circle"></i>
	<span>{{ environment.environmentName }} environment</span>
</div>
<p-toast></p-toast>
<router-outlet></router-outlet>
